import dayjs, { ConfigType } from "dayjs";
import ptBR from "dayjs/locale/pt-br";

dayjs.locale(ptBR);

// The site's only rendered date format: "10 de dez 2025".
//
// It lives here, next to the locale registration, on purpose. Gatsby only bundles
// gatsby-ssr into the HTML renderer when that file exports a recognised SSR API
// (services/initialize.js `hasAPIFile`: gatsby-browser is always included, gatsby-ssr
// only when `ssrAPIs` is non-empty). A side-effect-only `import "./src/dayjs-setup"`
// in a gatsby-ssr with no exports therefore never ran during the build, so every
// server-rendered date fell back to English — "de Dec 2025" — while the browser,
// which always loads gatsby-browser, showed pt-BR. Formatting through this module
// makes the locale a dependency of the format call itself, so it cannot be dropped
// again by an unrelated change to gatsby-ssr's exports.
export function formatShortDate(date: ConfigType): string {
  return dayjs(date).format("DD [de] MMM YYYY");
}
